import * as yup from 'yup'

const invoiceRateSchema = yup.object({
  id : yup.number(),
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), //Date
  created_by: yup.string().nullable(), // string
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), // Date,
  description : yup.string(),
  pileCount : yup.number().integer().nullable(),
  rate1 : yup.number().nullable(),
  rate2 : yup.number().nullable(),
  notes: yup.string().nullable()

})

const customerSchema = yup.object({
  id: yup.number(), //number
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), //Date
  created_by: yup.string().nullable(), // string
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), // Date
  name: yup.string().nullable(), //string
  companyName: yup.string().nullable(), //string
  invoiceName: yup.string().defined().required(), //string
  notes: yup.string().nullable(), //string
  //province: yup.mixed().oneOf(['AB','BC','SK','MB','ON','NB','NS']),
  email: yup.string().nullable().email(), //.default(''), //string
  //email: yup.string().email().transform((curr, orig) => (orig === '' ? 'empty@nothing.com' : curr)),
  projectCount: yup.number().nullable(),
  archived: yup.boolean(),
  source: yup.string().notRequired()
  //invoice_email : yup.string().email().nullable(),
  //invoice_emails : yup.array().of(yup.string().email()).nullable(),
  //closeout_email: yup.string().email().nullable(),
  //closeout_emails: yup.array().of(yup.string().email()).nullable()
})

const newCustomerSchema = yup.object({
  created_by: yup.string().defined(), // string
  name: yup.string(), //string
  companyName: yup.string(), //string
  invoiceName: yup.string().defined().required(), //string
  notes: yup.string(), //string
  email: yup.string().email().transform((val => {
    return val === '' || val === null ? "" : val;
  })), //string
  source: yup.string().notRequired()
})

const existingCustomerSchema = yup.object({
  id: yup.number().defined(), //number
  name: yup.string(), //string
  companyName: yup.string(), //string
  invoiceName: yup.string().defined().required(), //string
  notes: yup.string(), //string
  email: yup.string().email().transform((val => {
    return val === '' || val === null ? "" : val;
  })), //string
  source: yup
    .string()
    .notRequired()
    .transform((newVal) => (newVal === '' ? null : newVal)),
  archived: yup.boolean()
})

interface Customer extends yup.InferType<typeof customerSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

/*
interface LineItem {
  itemNo?: number
  description: string
  value: number
  tax: number
}*/

const lineItemSchema = yup.object({
  itemNo: yup.number().lessThan(7), //number
  description: yup.string().required().trim(),
  value: yup.number().required(),
  tax: yup.number().defined()
})

interface LineItem extends yup.InferType<typeof lineItemSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

const invoiceSchema = yup.object({
  id: yup.string(), //number
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), //Date
  created_by: yup.string().nullable(), //.defined(), // string 
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), // Date
  address: yup.string().defined(),
  projectId: yup.string().length(8).defined(),
  province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).defined(),
  taxRate: yup.number().min(0).max(1).positive().defined(),
  lineItems: yup.array().of(lineItemSchema).defined().min(1).transform((curr, orig) => (orig.length==0 ? [{'itemNo':1, 'description':'empty', 'value':0, 'tax':0}] : curr)),
  customer: customerSchema.defined(),
  customer_id: yup.number(),
  valueTotal: yup.number().defined(),
  taxTotal: yup.number().defined(),
  datePaid: yup.date().nullable().transform((curr, orig) => {curr === null || curr === "null" ? null : curr}),
  owner: yup.string(),
  engineer : yup.string(),
  owner_id : yup.number().defined(),
  engineer_id : yup.number().defined(),
  year : yup.number() //set by the db trigger when the invoice is created
})

const invoiceReportSchema = yup.object({
  source : yup.string(),
  'project id' : yup.number(),
  'project name' : yup.string(),
  'customer' : yup.string(),
  'invoice id' : yup.string(),
  'invoice value' : yup.number(),
  'one off' : yup.boolean()
})

interface Invoice extends yup.InferType<typeof invoiceSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

const postechPileSchema = yup.object({
  pileType: yup.string().defined(),
  torqueMin: yup
    .number()
    .min(0)
    .integer()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  torqueMax: yup
    .number()
    .min(0)
    .integer()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  pileCount: yup.number().positive().integer().defined()
})

interface PostechPile extends yup.InferType<typeof postechPileSchema> {
  // using interface instead of type generally gives nicer editor feedback
}


const postechSchema = yup.object({
  id: yup.number(),
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), //Date
  created_by: yup.string().nullable(), // string
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), // Date
  projectId: yup.number().defined(),
  installer: customerSchema.defined(),
  installer_id: yup.number(),
  pilesSupporting: yup.string().defined(),
  pileLoads: yup.mixed().oneOf(['Loads Calculated', 'Loads Provided by Others']),
  //stage?: string
  piles: yup.array().of(postechPileSchema).defined().min(1)
})

interface Postech extends yup.InferType<typeof postechSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

const gpsSchema = yup.object({
  lat: yup.number().default(-1).required(),
  lon: yup.number().default(-1).required()
})

//NEW division schema
const divisionSchema = yup.object({
  id : yup.number(),
  name : yup.string()
})

//revised 2026-04-01 , remove projectInfo interface
const projectSchema = yup.object({
  id: yup.string().length(8).defined(),
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)),
  created_by: yup.string(),
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)),
  streetAddress: yup.string().defined(),
  city: yup.string().defined(),
  province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).defined(),
  customer_id: yup.number(),
  customer: customerSchema.defined(),
  status: yup.array().defined(),
  //gps: yup.object().default({ lat: 50, lon: -114 }),
  gps: gpsSchema.defined(),
  scopes: yup.array(),
  description: yup.string().notRequired(),
  notes: yup.string().notRequired(),
  photosLink: yup.string().notRequired(),
  tags: yup.array().notRequired(),
  name: yup.string(),
  folderLink: yup.string().notRequired(),
  folderUrl: yup.string().notRequired(),
  folderId: yup.string().notRequired(),
  year: yup.string().length(4),
  folderName: yup.string().notRequired(),
  engineer: yup.string(),
  drafter: yup.string().nullable(),
  invoices: yup.array().of(invoiceSchema).nullable(),
  postechs: yup.array().of(postechSchema).nullable(),
  sequence : yup.number().notRequired(),
  owner : yup.string(),
  source : yup.string(),
  owner_id : yup.number().defined(),
  engineer_id : yup.number().defined(),
  division : divisionSchema.defined()
})

interface Project extends yup.InferType<typeof projectSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

interface Gps extends yup.InferType<typeof gpsSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

/*interface Gps {
  lat?: number
  lon?: number
}*/

const tagSchema = yup.object({
  id : yup.string().defined(),
  created_by : yup.string(),
  created_on : yup.date(),
  modified_on : yup.date(),
  name : yup.string()
})

interface Tag extends yup.InferType<typeof tagSchema>{
    // using interface instead of type generally gives nicer editor feedback
}

/*interface Tag {
  id: string
  creation?: Date
  creator?: string
  modified?: Date
  name: string
}*/

const pileTypeSchema = yup.object({
  name: yup.string().defined(),
  description: yup.string().defined(),
  manufacturer: yup.string(),
  ccmc: yup.string(),
  type: yup.string(),
  od_in: yup.number().positive(),
  helix_in: yup.number().positive(),
  length_ft: yup.number().positive(),
  od_mm: yup.number().positive(),
  t_mm: yup.number().positive()
})

interface PileType extends yup.InferType<typeof pileTypeSchema> {}

const closeoutSchema = yup.object({
  installer: yup.string().required(),
  streetAddress: yup.string().required(),
  city: yup.string().required(),
  province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).required(),
  paragraph2: yup.string().required(),
  paragraph3: yup.string().required(),
  paragraph4: yup.string().required(),
  //name: yup.string(),
  buildingCode: yup.string().required(),
  CofA: yup.string().required(),
  email: yup.string().required(),
  name: yup.string().required(),
  folderId: yup.string().required(),
  filename: yup.string().required(),
  date: yup.string().required()
})

const rateSchema = yup.object({
  creator: yup.string(),
  description : yup.string().required(),
  pileCount : yup.number().integer().nullable(),
  rate1 : yup.number(),
  rate2 : yup.number()
})
interface Rate extends yup.InferType<typeof rateSchema> {
  // using interface instead of type generally gives nicer editor feedback
}

enum Province {
  AB = 'AB',
  BC = 'BC',
  SK = 'SK',
  MB = 'MB',
  ON = 'ON',
  NB = 'NB',
  NS = 'NS'
}

enum Status {
  QUOTE = 'quote',
  DESIGN = 'design',
  REVIEWED = 'reviewed',
  INVOICED = 'invoiced',
  INSPECTION = 'inspection',
  CLOSEOUT = 'closeout',
  PAID = 'paid',
 // EMPTY = ''
}

const TaxOptions = Object.freeze({
  AB: { name: 'GST', rate: 0.05 },
  BC: { name: 'GST', rate: 0.05 },
  SK: { name: 'GST', rate: 0.05 },
  MB: { name: 'GST', rate: 0.05 },
  ON: { name: 'HST', rate: 0.13 },
  NS: { name: 'HST', rate: 0.15 },
  NB: { name: 'HST', rate: 0.15 }
})

enum Engineer {
  chris = 'Chris',
  steve = 'Steve',
  pat = 'Pat',
  roger = 'Roger'
}

enum Drafter {
  negar = 'Negar',
  neil = 'Neil',
  just = 'Just',
  dahan = 'Dahan'
}

export {
  Province,
  Status,
  Engineer,
  Drafter,
  projectSchema,
  TaxOptions,
  customerSchema,
  lineItemSchema,
  invoiceSchema,
  pileTypeSchema,
  postechSchema,
  postechPileSchema,
  closeoutSchema,
  invoiceRateSchema,
  newCustomerSchema,
  existingCustomerSchema,
  rateSchema,
  tagSchema,
  gpsSchema,
  invoiceReportSchema,
  divisionSchema
}
export type {
  LineItem,
  Invoice,
  Postech,
  Project,
  Customer,
  PileType,
  PostechPile,
  Tag,
  Rate,
  Gps
}
